// extracted by mini-css-extract-plugin
export default {"form":"wVeu86ncdA2HCEYJYRYQ","select":"J6jXareZFIgKqqLpIKeg"};